import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkIcon } from 'uitk-react-icons';
import { UitkTertiaryButton } from 'uitk-react-button';

const ButtonTracked = ClickTracker(UitkTertiaryButton);

export const MyList: React.FunctionComponent = () => (
  <div className="my-list">
    <ButtonTracked id="my-list-button" rfrr="PWA.Header.MyList" href="/lists" linkName="My List" data-stid="my-list-button">
      <UitkIcon name="favorite" className="my-list__icon" />
      <span className="is-visually-hidden">My List</span>
    </ButtonTracked>
  </div>
);
MyList.displayName = 'MyList';
